import React, { useState } from "react";
import { useQuery } from "react-query";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  TextField,
} from "@material-ui/core";

import { getMaestras } from "../../actions/maestras-actions";
import { REQUIRED_MESSAGE } from "../../constants";

const useStyles = makeStyles((theme) => ({
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  buttonClear: {
    color: "#666666",
    border: "solid 1px",
    background: "#ffffff",
    "&:hover": { color: "#099F9F", background: "#ffffff" },
  },
}));

export default function RequisitionVacant({
  requisitionId,
  onPublish,
  showForm,
  handleClose,
}) {
  const classes = useStyles();
  const [vacante, setVacante] = useState({
    id: "",
    tipoConvocatoria: "",
    salario: "",
    salarioConvenir: false,
    observation: ""
  });
  const [valid, setValid] = useState({
    tipoConvocatoria: true,
    salario: true,
    observation:true,
  });
  const [isSalaryRequired, setIsSalaryRequired] = useState(true);

  const validateFields = (name, value) => {
    if (name === "salario") {
      if (isSalaryRequired && !value) {
        setValid((inv) => ({
          ...inv,
          [name]: false,
        }));
      } else {
        setValid((inv) => ({
          ...inv,
          [name]: true,
        }));
      }
    } else {
      if (!value) {
        setValid((inv) => ({
          ...inv,
          [name]: false,
        }));
      } else {
        setValid((inv) => ({
          ...inv,
          [name]: true,
        }));
      }
    }
  };

  const addDots = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

  const handleSalaryKeyPress = (e) => {
    let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    if (!validChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const addValuesToMemory = (e) => {
    const { name, value } = e.target;
    validateFields(name, value);
    if (name === "salario") {
      let sal = addDots(removeNonNumeric(value));
      setVacante((anterior) => ({
        ...anterior,
        [name]: sal,
        "id": requisitionId,
      }));
    } else {
      setVacante((anterior) => ({
        ...anterior,
        [name]: value,
        "id": requisitionId,
      }));
    }
  };

  const handleChange = (event) => {
    setVacante({ ...vacante, [event.target.name]: event.target.checked });
    if (event.target.checked) {
      setIsSalaryRequired(false);
      setVacante((anterior) => ({
        ...anterior,
        "salario": 0,
      }));
    } else {
      setIsSalaryRequired(true);
    }
  };

  const getListaMaestras = async () => {
    const response = await getMaestras();
    return response.data.maestras;
  };

  const { data: dataListaMaestras, status: statusListaMaestras } = useQuery(
    "listaMaestras",
    getListaMaestras
  );

  const validate = () => {
    if (isSalaryRequired && !vacante.salario) {
      setValid((inv) => ({
        ...inv,
        "salario": false,
      }));
    } else {
      setValid((inv) => ({
        ...inv,
        "salario": true,
      }));
    }
    if (!vacante.tipoConvocatoria) {
      setValid((inv) => ({
        ...inv,
        "tipoConvocatoria": false,
      }));
    } else {
      setValid((inv) => ({
        ...inv,
        "tipoConvocatoria": true,
      }));
    }
    if (!vacante.observation) {
      setValid((inv) => ({
        ...inv,
        "observation": false,
      }));
    } else {
      setValid((inv) => ({
        ...inv,
        "observation": true,
      }));
    }
    if ((isSalaryRequired && !vacante.salario) || !vacante.tipoConvocatoria || !vacante.observation) {
      return false;
    } else {
      return true;
    }
  };

  const clearVacant = () => {
    setVacante({
      id: "",
      tipoConvocatoria: "",
      salario: "",
      salarioConvenir: false,
      observation: ""
    });
    setValid({
      tipoConvocatoria: true,
      salario: true,
      observation:true,
    });
    setIsSalaryRequired(true);
  };

  const onHandleClose = () => {
    clearVacant();
    setIsSalaryRequired(true);
    handleClose();
  };

  const publish = () => {
    let isValid = validate();
    if (!isValid) {
      return;
    }
    let vacantData = vacante;
    clearVacant();
    onPublish(vacantData);
  };

  return (
    statusListaMaestras === "success" && (
      <div className={classes.root}>
        <Dialog
          open={showForm}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent style={{ width: "350px" }}>
            <FormControl
              fullWidth
              size="small"
              className={classes.margin}
              style={{ marginBottom: "0px", marginTop: "15px" }}
              variant="outlined"
            >
              <InputLabel htmlFor="outlined-adornment-amount">
                Salario
              </InputLabel>
              <OutlinedInput
                size="small"
                name="salario"
                id="outlined-adornment-amount"
                value={vacante.salario}
                inputProps={{ maxLength: 20 }}
                disabled={!isSalaryRequired}
                onKeyPress={handleSalaryKeyPress}
                onChange={addValuesToMemory}
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
                labelWidth={60}
              />
            </FormControl>
            <FormHelperText style={{ color: "#f44336" }}>
              {!valid.salario && REQUIRED_MESSAGE}
            </FormHelperText>
            <TextField
              fullWidth
              size="small"
              name="tipoConvocatoria"
              id="outlined-select-currency"
              select
              label="Tipo de convocatoria"
              value={vacante.tipoConvocatoria}
              onChange={addValuesToMemory}
              //helperText="Por favor seleccione el tipo de convocatoria"
              variant="outlined"
              style={{ marginTop: "15px" }}
            >
              {statusListaMaestras === "success" &&
                dataListaMaestras?.tipoConvocatoria &&
                dataListaMaestras.tipoConvocatoria.map((option) => (
                  <MenuItem key={option.clave} value={option.clave}>
                    {option.valor}
                  </MenuItem>
                ))}
            </TextField>
            <FormHelperText style={{ color: "#f44336" }}>
              {!valid.tipoConvocatoria && REQUIRED_MESSAGE}
            </FormHelperText>
            <FormControl
              fullWidth
              style={{ height: "200px", paddingTop: "20px" }}
            >
              <TextField
                style={{ height: "150px" }}
                fullWidth
                defaultValue=""
                InputLabelProps={{ shrink: true }}
                multiline
                required={true}
                rows={8}
                rowsMax={8}
                variant="outlined"
                className={classes.field}
                type="text"
                autoComplete="off"
                label="Observaciones"
                name="observation"
                size="small"
                inputProps={{ maxLength: 1000 }}
                onChange={addValuesToMemory}
                value={vacante.observation}
              />
            </FormControl>
            <FormHelperText style={{ color: "#f44336" }}>
              {!valid.observation && REQUIRED_MESSAGE}
            </FormHelperText>

            <FormControlLabel
              control={
                <Checkbox
                  checked={vacante.salarioConvenir}
                  onChange={handleChange}
                  name="salarioConvenir"
                  color="primary"
                />
              }
              label="Salario a convenir"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onHandleClose} className={classes.buttonClear}>
              Cancelar
            </Button>
            <Button onClick={publish} className={classes.buttonSearch}>
              Publicar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  );
}
